import { PlayerProvider } from '@project-minerva/assessment-player'
import { ReactNode } from 'react'
import { StudySessionProvider } from '../data/study-session.provider'

export const TestPageWrapper = ({ children }: { children: ReactNode }) => (
  <StudySessionProvider>
    <PlayerProvider>{children}</PlayerProvider>
  </StudySessionProvider>
)
